import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useAddRecruitmentStatusDefinition = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.recruitmentAddStatusDefinition,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.recruitmentStatuses]);
    },
  });
};
